import store from '@/core/store'

class UsuarioSemDominioIdCondition {
    shouldExecute(to) {
        const nomeRota = to && to.name
        const destinosPermitidosSemDominio = ['NaoAutorizado', 'PaginaNaoEncontrada']
        const indoParaDestinoPermitido = destinosPermitidosSemDominio.indexOf(nomeRota) !== -1
        return !this.runningCondition(to) && !store.state.loki.user.domainId && !indoParaDestinoPermitido
    }

    runningCondition(to) {
        return to.name === 'SelecionarDominio'
    }

    execute(to, from, next) {
        try {
            const base = `${window.location.origin}${window.location.pathname}`
            const path = to && typeof to.fullPath === 'string' ? to.fullPath : '/'
            const absolute = `${base}#${path.replace(/^#?\//, '/')}`
            const redirectUrl = encodeURIComponent(absolute)
            next({ name: 'SelecionarDominio', query: { redirectUrl } })
        } catch (e) {
            next({ name: 'SelecionarDominio' })
        }
    }
}

export default new UsuarioSemDominioIdCondition()
